import { render } from "./qrthorizondalpercentage.vue?vue&type=template&id=0b2c814c&scoped=true"
import script from "./qrthorizondalpercentage.vue?vue&type=script&lang=js"
export * from "./qrthorizondalpercentage.vue?vue&type=script&lang=js"

import "./qrthorizondalpercentage.vue?vue&type=style&index=0&id=0b2c814c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2c814c"]])

export default __exports__